import { Injectable, inject } from '@angular/core';
import {
  SmartVideoAssetSequenceRenderOptions,
  SmartVideoAssetSequenceRendererService
} from './smart-video-asset-sequence-renderer.service';
import { RenderProgressStore } from '../../shared/state/render-progress.store';
import { RenderSessionStore } from '../../shared/state/render-session.store';

@Injectable({ providedIn: 'root' })
export class SmartVideoAssetsRenderFlowService {
  private readonly sequenceRenderer = inject(SmartVideoAssetSequenceRendererService);
  private readonly progressStore = inject(RenderProgressStore);
  private readonly sessionStore = inject(RenderSessionStore);

  async renderAssetsToVideo(options: SmartVideoAssetSequenceRenderOptions) {
    this.sessionStore.start({
      flow: 'smart-video-assets',
      category: 'non-editor',
      surface: 'review-image-sequence',
      pipeline: 'SmartVideo',
      isShort: options.aspectRatio !== '16:9'
    });

    try {
      const rendered = await this.sequenceRenderer.render({
        ...options,
        onProgress: progress => {
          this.progressStore.set(progress);
          this.sessionStore.update({ status: progress.phase, progress });
          options.onProgress?.(progress);
        }
      });
      this.sessionStore.complete();
      return rendered;
    } catch (err) {
      this.sessionStore.fail(this.errorMessage(err));
      throw err;
    }
  }

  private errorMessage(err: unknown): string {
    return err instanceof Error ? err.message : 'Smart Video assets render failed.';
  }
}
